import { useContext } from "react";

import CoreContext from "../contexts/core-context";

export function useCore() {
	const context = useContext(CoreContext);
	return context;
}
